<template>
  <v-dialog
    persistent
    v-model="dialogShow"
    max-width="750px">
    <div class="layerPopup">
      <div class="layerTit">
        チケット一括適用
      </div>
      <div class="layerContent large">
        <div class="batchDialogBox">
          <dl class="ticketList">
            <dt>チケット ID</dt>
            <dd>
              <ul>
                <li v-for="ticket in batchTargetTickets" :key="ticket.id"><span>{{ticket.dispId}}</span></li>
              </ul>
            </dd>
          </dl>

          <table class="UXTbl">
            <colgroup>
              <col style="width:110px;" />
              <col style="width:245px" />
              <col style="width:100px;" />
              <col />
            </colgroup>
            <tbody>
            <tr>
              <th>状態</th>
              <td>
                <v-select
                  v-model="statusType"
                  :items="statuses"
                  item-value="id"
                  item-text="name"
                  class="UXselect"
                  color="#6D8DFF"
                  hide-details
                  outline
                  solo
                  :menu-props="{contentClass:'UXselectFixed'}"
                  no-data-text="データがありません。"
                ></v-select>
              </td>
              <th>優先順位</th>
              <td>
                <v-select
                  v-model="priorityType"
                  :items="priorities"
                  item-value="id"
                  item-text="name"
                  class="UXselect"
                  color="#6D8DFF"
                  hide-details
                  outline
                  solo
                  :menu-props="{contentClass:'UXselectFixed'}"
                  no-data-text="データがありません。"
                ></v-select>
              </td>
            </tr>
            <tr>
              <th>担当者</th>
              <td colspan="3">
                <v-select
                  v-model="agent"
                  :items="agents"
                  item-value="id"
                  item-text="name"
                  class="UXselect"
                  color="#6D8DFF"
                  hide-details
                  outline
                  solo
                  :menu-props="{contentClass:'UXselectFixed'}"
                  no-data-text="データがありません。"
                ></v-select>
              </td>
            </tr>
            <tr>
              <th>分類カテゴリ</th>
              <td colspan="3">
                <div class="inlineFlex">
                  <p>
                    <v-select
                      label="大分類"
                      item-text="taskTypeName"
                      item-value="taskTypeId"
                      v-model="majorTaskType"
                      :items="majorTaskList"
                      @change="setMajorTaskType"
                      :disabled="disabled"
                      class="UXselect"
                      color="#6D8DFF"
                      hide-details
                      outline
                      solo
                      :menu-props="{contentClass:'UXselectFixed typeSize'}"
                      no-data-text="データがありません。"
                    ></v-select>
                  </p>
                  <p>
                    <v-select
                      label="中分類"
                      item-text="taskTypeName"
                      item-value="taskTypeId"
                      v-model="middleTaskType"
                      :items="middleTaskList"
                      @change="setMiddleTaskType"
                      :disabled="disabled"
                      class="UXselect"
                      color="#6D8DFF"
                      hide-details
                      outline
                      solo
                      :menu-props="{contentClass:'UXselectFixed typeSize'}"
                      no-data-text="データがありません。"
                    ></v-select>
                  </p>
                  <p>
                    <v-select
                      label="小分類"
                      item-text="taskTypeName"
                      item-value="taskTypeId"
                      v-model="minorTaskType"
                      :items="minorTaskList"
                      :disabled="disabled"
                      @change="setMinorTaskType"
                      class="UXselect"
                      color="#6D8DFF"
                      hide-details
                      outline
                      solo
                      :menu-props="{contentClass:'UXselectFixed typeSize'}"
                      no-data-text="データがありません。"
                    ></v-select>
                  </p>
                </div>
              </td>
            </tr>
            <tr>
              <th>タグを追加</th>
              <td colspan="3">
                <batch-ticket-tag-list ref="taglist"></batch-ticket-tag-list>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="cenBtn" style="padding:30px 0 20px 0;">
            <v-btn outline round large class="UXbtn widthAuto" @click="hideDialog">閉じる</v-btn>
            <v-btn round dark large color="#ff8c8c" class="UXbtn widthAuto" :loading="loading" :disabled="loading" @click="apply">適用</v-btn>
          </div>
        </div>
      </div>
      <div class="layerClose">
        <v-btn flat icon @click="hideDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {mapGetters} from 'vuex'
import eventBus from '@/event_bus'
import event from '../../../enums/eventType'
import batchTicketTagList from './batch_ticket_tag_list'
import TicketListUtil from '../../../util/ticket_list_util'

export default {
  name: 'batch_dialog',
  components: {
    batchTicketTagList
  },
  computed: {
    ...mapGetters([
      'currentTicketBrandId'
    ])
  },
  props: {
    batchTargetTickets: Array,
    callAllTicketList: Function
  },
  data () {
    return {
      dialogShow: false,
      loading: false,
      statuses: [],
      statusType: null,
      priorities: [],
      priorityType: null,
      agents: [],
      agent: null,
      majorTaskType: null,
      middleTaskType: null,
      minorTaskType: null,
      majorTaskList: [],
      middleTaskList: [],
      minorTaskList: [],
      disabled: false
    }
  },
  created () {
    this.ticketEnums()
  },
  mounted () {
    eventBus.$on(event.OPEN_TICKET_BATCH_DIALOG, () => {
      this.clearData()
      // 상담사가 팝업 열 때 마다 호출 한다. (도중에 추가 될 수 있기에)
      this.findAgent()
      this.showDialog()
      this.callMajorTaskType()
    })
  },
  beforeDestroy () {
    eventBus.$off(event.OPEN_TICKET_BATCH_DIALOG)
  },
  methods: {
    showDialog () {
      this.dialogShow = true
    },
    hideDialog () {
      this.agent = null
      this.majorTaskType = null
      this.middleTaskType = null
      this.minorTaskType = null
      this.$refs.taglist.removeTaginp()
      this.dialogShow = false
    },
    clearData () {
      this.statusType = null
      this.priorityType = null
      this.$refs.taglist.tags = []
    },
    baseStatuses () {
      this.statuses = []
      this.statuses.push({id: null, name: '-'})
    },
    basePriorities () {
      this.priorities = []
      this.priorities.push({id: null, name: '-'})
    },
    baseAgents () {
      this.agents = []
      this.agents.push({id: null, name: '-'})
    },
    /* 상태값 조회 */
    ticketEnums () {
      this.baseStatuses()
      this.basePriorities()
      this.axios.get('/gateway/ticket/enums')
        .then(res => {
          if (res.data.code === 0) {
            const data = res.data.data

            data.ticketStatus.forEach(status => {
              let item = {
                id: status.key,
                name: status.value
              }
              this.statuses.push(item)
            })
            data.ticketPriority.forEach(priority => {
              let item = {
                id: priority.key,
                name: priority.value
              }
              this.priorities.push(item)
            })
          }
        })
    },
    /* 담당자 조회 */
    findAgent () {
      this.axios.get(`/gateway/ticket/agent/list/${this.currentTicketBrandId}?page=1&size=100`)
        .then(res => {
          if (res.data.code === 0) {
            this.baseAgents()

            const data = res.data.data
            data.forEach(agent => {
              let item = {
                id: agent.id,
                name: agent.name
              }
              this.agents.push(item)
            })
          }
        })
    },
    /* 적용 */
    apply () {
      if (!this.isChanged()) {
        return
      }
      this.loading = true
      this.axios.post('/gateway/ticket/batch',
        {
          brandId: this.currentTicketBrandId,
          ticketIds: TicketListUtil.getTicketIdsFromTicketArr(this.batchTargetTickets),
          ticketStatus: this.statusType,
          ticketPriority: this.priorityType,
          agentId: this.agent,
          tags: this.$refs.taglist.tags,
          majorTaskTypeId: this.majorTaskType,
          middleTaskTypeId: this.middleTaskType,
          minorTaskTypeId: this.minorTaskType
        })
        .then(res => {
          if (res.data.code !== 0) {
            this.$alertMsg(res.data.message)
            return
          }
          this.$alertMsg('適用されました。')
          this.updateTicketList()
          this.hideDialog()
        })
        .finally(() => {
          this.loading = false
          this.clearTaskType()
        })
    },
    /* 변경 여부 확인 */
    isChanged () {
      if (this.statusType === null && this.priorityType === null && this.agent === null && this.$refs.taglist.tags.length === 0 && this.isMajorTaskTypeInvalid()) {
        this.hideDialog()
        return false
      }
      return true
    },
    isMajorTaskTypeInvalid () {
      return (this.majorTaskType === null || this.majorTaskType === undefined)
    },
    updateTicketList () {
      this.callAllTicketList(1, true)
    },
    // 상담 분류 관련 메소드
    setMajorTaskType () {
      const data = this.majorTaskType
      this.middleTaskList = []
      this.minorTaskList = []
      this.updateMajorTaskType(data)
      this.middleTaskType = null
      this.minorTaskType = null
      this.callMiddleTaskType()
    },
    setMiddleTaskType () {
      const data = this.middleTaskType
      this.minorTaskList = []
      this.updateMiddleTaskType(data)
      this.minorTaskType = null
      this.callMinorTaskType()
    },
    setMinorTaskType () {
      const data = this.minorTaskType
      this.updateMinorTaskType(data)
    },
    callMajorTaskType () {
      if (this.currentTicketBrandId) {
        this.axios.get('/gateway/ticket/brand/taskType/major', {
          params: {
            ticketBrandId: this.currentTicketBrandId
          }
        }).then((res) => {
          this.majorTaskList = res.data.data
        })
      }
    },
    callMiddleTaskType () {
      if (this.currentTicketBrandId && this.majorTaskType) {
        this.axios.get('/gateway/ticket/brand/taskType/middle', {
          params: {
            ticketBrandId: this.currentTicketBrandId,
            parentTaskTypeId: this.majorTaskType
          }
        }).then((res) => {
          this.middleTaskList = res.data.data
        })
      }
    },
    callMinorTaskType () {
      if (this.currentTicketBrandId && this.middleTaskType) {
        this.axios.get('/gateway/ticket/brand/taskType/minor', {
          params: {
            ticketBrandId: this.currentTicketBrandId,
            parentTaskTypeId: this.middleTaskType
          }
        }).then((res) => {
          this.minorTaskList = res.data.data
        })
      }
    },
    updateMajorTaskType (type) {
      this.majorTaskType = type
      this.middleTask = null
      this.minorTask = null
    },
    updateMiddleTaskType (type) {
      this.middleTaskType = type
      this.minorTask = null
    },
    updateMinorTaskType (type) {
      this.minorTaskType = type
    },
    clearTaskType () {
      this.majorTaskType = null
      this.middleTaskType = null
      this.minorTaskType = null
    }
  }
}
</script>

<style lang="scss">
.batchDialogBox {
  dl.ticketList {
    padding-bottom: 10px;
    dt {
      padding-bottom:5px;
      color:$gray-8;
      font-weight: bold;
      font-size: 14px;
    }
    dd {
      border:1px solid #C4C4C4;
      border-radius: 3px;
      ul {
        padding:10px;
        height:140px;
        overflow-y:auto;
        li {
          padding: 0 5px 5px 0;
          list-style: none;
          display: inline-flex;
          justify-content: flex-start;
          align-items: center;
          span {
            padding:0 10px;
            display:inline-block;
            height:35px;
            line-height:35px;
            font-size: 14px;
            color: $gray-8;
            background: $gray-2;
            border-radius: 3px;
          }
        }
      }
    }
  }
  .inlineFlex {
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    p {
      margin: 0;
      padding-right:10px;
      width: 33.33%;
      &:last-child {
        padding-right: 0;
      }
    }
  }
}
.typeSize {
  width: 183px;
}
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/dialog/batch_dialog.vue